import React, { useState, useCallback, useEffect } from 'react';
import communicationApi from '../../../../services/communication'
import { showLoader, hideLoader } from "../../../../redux/loader/actions";
import { useDispatch } from "react-redux";
import {
    Card, Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TextField, Paper, InputAdornment,
    Checkbox, FormControlLabel, Grid, Button, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

const planName = ["Basic"];
const frequencies = ["1 Month"];
const planColors = ["#e0f7fa", "#b3e5fc", "#c8e6c9"];

const Communication = () => {
    const dispatch = useDispatch();
    const [communicationTypes, setCommunicationTypes] = useState([]);
    const [communicationPlan, setCommunicationPlan] = useState([]);
    const [isOfferApplicable, setIsOfferApplicable] = useState(false);

    const [tableData, setTableData] = useState(
        planName.map(() =>
            frequencies.map(() => ({
                discount: '',
                price: '',
                offerPrice: '',
                offerPercentage: ''
            }))
        )
    );

    const handleChange = (planIndex, freqIndex, field, value) => {
        const updatedData = tableData.map((plan, pIdx) =>
            plan.map((freq, fIdx) => {
                if (pIdx === planIndex && fIdx === freqIndex) {
                    return { ...freq, [field]: value };
                }
                return freq;
            })
        );
        setTableData(updatedData);
    };

    const handleSubmit = () => {
        console.log('Form submitted with data:', tableData);
        alert('Form submitted successfully!');
    };

    const [formData, setFormData] = useState({
        communicationType: ''
    });
    const handleFormChange = (e, _, fieldName) => {
        const { value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [fieldName]: value
        }));
    };

    const formik = useFormik({
        initialValues: {
            communicationType: '',
        },
        validationSchema: Yup.object({
            communicationType: Yup.string().required("Communication Type is required"),


        }),
        onSubmit: handleSubmit,
    });


    const getAllCommunicationType = useCallback(() => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            console.log('API response:', res);
            const types = Array.isArray(res?.data?.data) ? res.data.data : [];
            setCommunicationTypes(types);
            dispatch(hideLoader());
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch communication types', err);
        };

        communicationApi.getAllCommunicationType().then(onSuccess, onFailure);
    }, []);

    useEffect(() => {
        getAllCommunicationType();
    }, [getAllCommunicationType]);



    const getAllcommunicationPricing = useCallback((communication_type_uuid, plan_uuid = null) => {
        dispatch(showLoader());

        // const onSuccess = (res) => {
        //     console.log('API response:', res);
        //     const types = Array.isArray(res?.data?.data) ? res.data.data : [];
        //     setCommunicationPlan(types);
        //     dispatch(hideLoader());
        // };
        const onSuccess = (res) => {
            const responseData = res?.data?.data || [];

            // Extract unique plans and their frequencies
            const groupedPlans = responseData.reduce((acc, item) => {
                const planName = item.productPlan?.plan_name || 'Unnamed Plan';
                const frequencies = item.frequency || [];

                if (!acc[planName]) {
                    acc[planName] = new Set();
                }

                frequencies.forEach(freq => acc[planName].add(freq));
                return acc;
            }, {});

            // Convert Sets to Arrays for rendering
            const processedPlans = Object.entries(groupedPlans).map(([plan, freqSet]) => ({
                plan,
                frequencies: Array.from(freqSet),
            }));

            setCommunicationPlan(processedPlans);

            // Initialize table data for editing/input
            const initialData = processedPlans.map(({ frequencies }) =>
                frequencies.map(() => ({
                    discount: '',
                    price: '',
                    offerPrice: '',
                    offerPercentage: '',
                }))
            );
            setTableData(initialData);
            dispatch(hideLoader());
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch communication pricing', err);
        };

        const page = 1;
        const pageSize = 10;

        communicationApi
            .getAllPricing(page, pageSize, communication_type_uuid, plan_uuid)
            .then(onSuccess)
            .catch(onFailure);
    }, []);



    return (
        <Box sx={{ p: 2 }}>
            <Card elevation={3} sx={{ p: 3, mb: 2 }}>
                <Typography sx={{ mb: 2, color: '#a00', fontSize: '20px', fontWeight: '600' }}>
                    Communication Channel
                </Typography>

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    {!isOfferApplicable && (
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                select
                                label="Communication type"
                                name="communicationType"
                                value={formik.values.communicationType}
                                onChange={(e) => {
                                    const selectedUuid = e.target.value;
                                    formik.setFieldValue("communicationType", selectedUuid);
                                    console.log("Selected UUID:", selectedUuid);
                                    getAllcommunicationPricing(selectedUuid);
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.communicationType && Boolean(formik.errors.communicationType)}
                                helperText={
                                    formik.touched.communicationType && formik.errors.communicationType
                                        ? formik.errors.communicationType
                                        : " "
                                }
                            >
                                {communicationTypes.map((type) => (
                                    <MenuItem
                                        key={type.communication_type_uuid}
                                        value={type.communication_type_uuid}
                                    >
                                        {type.communication_type.charAt(0).toUpperCase() +
                                            type.communication_type.slice(1).toLowerCase()}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                    )}

                    <Grid item xs={12} sm={12} md={3}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isOfferApplicable}
                                    onChange={() => setIsOfferApplicable((prev) => !prev)}
                                />
                            }
                            label="Offer Applicable"
                            sx={{ marginBottom: 2 }}
                        />
                    </Grid>



                    {isOfferApplicable && (
                        <>
                            <Grid item xs={12} sm={12} md={3}>
                                <TextField
                                    type="date"
                                    label="Offer Valid From"
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ width: "100%" }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3}>
                                <TextField
                                    type="date"
                                    label="Offer Valid To"
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ width: "100%" }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3}>
                                <TextField
                                    label="Offer Text"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Plan</TableCell>
                                <TableCell align="center">Frequency</TableCell>
                                <TableCell align="center">Frequency Discount (%)</TableCell>
                                <TableCell align="center">Price (INR)</TableCell>
                                {isOfferApplicable && (
                                    <>
                                        <TableCell align="center">Offer Price (INR)</TableCell>
                                        <TableCell align="center">Offer Percentage (%)</TableCell>
                                    </>
                                )}
                            </TableRow>
                        </TableHead>

                        {/* <TableBody>
                            {planName.map((plan, planIndex) =>
                                frequencies.map((frequency, freqIndex) => (
                                    <TableRow key={`${planIndex}-${freqIndex}`}>
                                        {freqIndex === 0 && (
                                            <TableCell
                                                align="center"
                                                rowSpan={frequencies.length}
                                                sx={{
                                                    backgroundColor: planColors[planIndex % planColors.length],
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {plan}
                                            </TableCell>
                                        )}
                                        <TableCell align="center">{frequency}</TableCell>

                                        <TableCell align="center">
                                            <TextField
                                                variant="outlined"
                                                value={tableData[planIndex][freqIndex].discount}
                                                onChange={(e) => handleChange(planIndex, freqIndex, 'discount', e.target.value)}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                }}
                                                sx={{ width: "100%", textAlign: "center" }}
                                            />
                                        </TableCell>

                                        <TableCell align="center">
                                            <TextField
                                                variant="outlined"
                                                value={tableData[planIndex][freqIndex].price}
                                                onChange={(e) => handleChange(planIndex, freqIndex, 'price', e.target.value)}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                                }}
                                                sx={{ width: "100%", textAlign: "center" }}
                                            />
                                        </TableCell>

                                        {isOfferApplicable && (
                                            <>
                                                <TableCell align="center">
                                                    <TextField
                                                        variant="outlined"
                                                        value={tableData[planIndex][freqIndex].offerPrice}
                                                        onChange={(e) => handleChange(planIndex, freqIndex, 'offerPrice', e.target.value)}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                                        }}
                                                        sx={{ width: "100%", textAlign: "center" }}
                                                    />
                                                </TableCell>

                                                <TableCell align="center">
                                                    <TextField
                                                        variant="outlined"
                                                        value={tableData[planIndex][freqIndex].offerPercentage}
                                                        onChange={(e) => handleChange(planIndex, freqIndex, 'offerPercentage', e.target.value)}
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                        }}
                                                        sx={{ width: "100%", textAlign: "center" }}
                                                    />
                                                </TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                ))
                            )}
                        </TableBody> */}
                        <TableBody>
                            {communicationPlan.map((planItem, planIndex) =>
                                planItem.frequencies.map((frequency, freqIndex) => (
                                    <TableRow key={`${planIndex}-${freqIndex}`}>
                                        {freqIndex === 0 && (
                                            <TableCell
                                                align="center"
                                                rowSpan={planItem.frequencies.length}
                                                sx={{
                                                    backgroundColor: planColors[planIndex % planColors.length],
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {planItem.plan.charAt(0).toUpperCase() + planItem.plan.slice(1)}

                                            </TableCell>
                                        )}

                                        <TableCell align="center">
                                            {frequency.charAt(0).toUpperCase() + frequency.slice(1)}
                                        </TableCell>


                                        <TableCell align="center">
                                            <TextField
                                                variant="outlined"
                                                value={tableData[planIndex][freqIndex].discount}
                                                onChange={(e) =>
                                                    handleChange(planIndex, freqIndex, 'discount', e.target.value)
                                                }
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                }}
                                                sx={{ width: "100%", textAlign: "center" }}
                                            />
                                        </TableCell>

                                        <TableCell align="center">
                                            <TextField
                                                variant="outlined"
                                                value={tableData[planIndex][freqIndex].price}
                                                onChange={(e) =>
                                                    handleChange(planIndex, freqIndex, 'price', e.target.value)
                                                }
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                                }}
                                                sx={{ width: "100%", textAlign: "center" }}
                                            />
                                        </TableCell>

                                        {isOfferApplicable && (
                                            <>
                                                <TableCell align="center">
                                                    <TextField
                                                        variant="outlined"
                                                        value={tableData[planIndex][freqIndex].offerPrice}
                                                        onChange={(e) =>
                                                            handleChange(planIndex, freqIndex, 'offerPrice', e.target.value)
                                                        }
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                                        }}
                                                        sx={{ width: "100%", textAlign: "center" }}
                                                    />
                                                </TableCell>

                                                <TableCell align="center">
                                                    <TextField
                                                        variant="outlined"
                                                        value={tableData[planIndex][freqIndex].offerPercentage}
                                                        onChange={(e) =>
                                                            handleChange(planIndex, freqIndex, 'offerPercentage', e.target.value)
                                                        }
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                        }}
                                                        sx={{ width: "100%", textAlign: "center" }}
                                                    />
                                                </TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                ))
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>


                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        sx={{
                            height: "100%",
                            background:
                                "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                            color: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                            textTransform: "uppercase",
                            fontWeight: "bold",
                            "&:hover": {
                                background:
                                    "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
                            },
                        }}
                    >
                        Submit
                    </Button>
                </Box>
            </Card>
        </Box>
    );
};

export default Communication;
